import { indentBlocks, indentList } from "./indent.helper";

export const MAX_INDENT_LEVEL = 14;
export const INDENT_SIZE = 40;

export class IndentCommand {
  constructor(editor) {
    this.editor = editor;
  }

  execute() {
    const selection = this.editor.selection;
    const selectedBlocks = selection.getSelectedBlocks();

    const savedSelection = this.saveSelection()

    if (!selectedBlocks || selectedBlocks.length === 0) return;

    // Tách block thường và list
    const listBlocks = selectedBlocks.filter(
      (block) => block.tagName.toLowerCase() !== "li"
    );

    const listLis = selectedBlocks.filter(
      (block) => block.tagName.toLowerCase() === "li"
    );

    // 👉 INDENT BLOCK
    if (listBlocks.length > 0) {
      indentBlocks({ blocks: listBlocks });
    }

    // 👉 INDENT LIST
    if (listLis.length > 0) {
      indentList({ blocks: listLis });
    }

    // 🔥 Quan trọng: rebuild selection sau khi DOM thay đổi
    this.restoreSelection(savedSelection);
  }

  saveSelection() {
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0) return null;

    const range = sel.getRangeAt(0);

    return {
      startContainer: range.startContainer,
      startOffset: range.startOffset,
      endContainer: range.endContainer,
      endOffset: range.endOffset,
    };
  }

  restoreSelection(saved) {
    if (!saved) return;

    const sel = window.getSelection();
    if (!sel) return;

    try {
      const range = document.createRange();

      range.setStart(saved.startContainer, saved.startOffset);
      range.setEnd(saved.endContainer, saved.endOffset);

      sel.removeAllRanges();
      sel.addRange(range);
    } catch (e) {
      console.warn("Restore failed → fallback");
    }
  }
}